import { Modal } from "react-bootstrap";
import { _get } from "../../../../api/apiClient";
import exportimages from "../../../../assets/images/exportImages";
import { toastResponse } from "../../../Common/Toast/Toast";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { formatCategoryName } from "../../../Bank/widget/widgetsCommonFunction";
import { useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import "./UpgradeCardPopUp.scss";
import PropTypes from "prop-types";

export const ContactSalesTeamModal = (props) => {
  const [currentToast, setCurrentToast] = useState("");
  const [successFlag, setSuccessFlag] = useState(false);
  const params = useParams();
  const authReducer = useSelector((state) => state.authReducer);
  const userRole = authReducer.userData.role?.toLowerCase();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSuccessFlag(false);
  }, [props]);
  const navigate = useNavigate();
  const showToast = (message, status) => {
    if (message !== currentToast) {
      if (status === "error") {
        toast.error(toastResponse("error", message));
      } else {
        toast.success(toastResponse("success", message));
      }
      setCurrentToast(message);
      setTimeout(() => setCurrentToast(""), 5500);
    }
  };
  const handleClick = async () => {
    if (successFlag) {
      props.onHide();

      let currentUrl = globalThis.location.href;
      if (
        currentUrl.includes("/financial-health-score") ||
        currentUrl.includes("/drilldown/graph")
      ) {
        navigate(`/bank/health-analysis/report/${params?.hid}`);
      }
    } else {
      let existing =
        props?.cardData?.name === "upgrade_email_campaign" ? "Pro" : "Freemium";
      let involved;

      if (existing === "Freemium") {
        involved = "Pro";
      } else if (existing === "Pro") {
        involved = "Marketing";
      } else {
        involved = "Pro";
      }
      setLoading(true);
      try {
        const response = await _get(
          `/client/pro/request?vFeature=${formatCategoryName(
            props?.cardData?.name,
          )}&vExistingTier=${existing}&vInvolvedTier=${involved}`,
        );
        if (response.data.status === "SUCCESS") {
          setSuccessFlag(true);
        }
      } catch (error) {
        showToast(error?.data?.message, "error");
      }
      setLoading(false);
    }
  };
  return (
    <Modal
      {...props}
      size="lg"
      restoreFocus={"true"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="chamelonTourPopup"
    >
      <Modal.Header className="p-0 m-0 d-none" closeButton />
      <Modal.Body
        style={{ padding: "0px", position: "relative", overflow: "hidden" }}
        className="pt-0 m-0"
        closeButton
      >
        <button
          className="position-absolute cursor-pointer btn btn-link p-0 border-0"
          style={{ right: "15px", top: "15px" }}
          onClick={() => props.onHide()}
          aria-label="Close modal"
        >
          <img
            src={exportimages.FU_cross}
            alt=""
          />
        </button>
        <div className="d-flex ">
          <div className="w-50">
            <img
              src={
                successFlag
                  ? exportimages?.contact_sales_team_success_upgrade
                  : exportimages?.contact_sales_team_upgrade
              }
              style={{ left: "-0.5%", position: "relative", height: "100%" }}
              alt=""
            />
          </div>

          <div className="d-flex align-items-start flex-column bd-highlight mb-2 p-12 p-xxl-9">
            <div className="mb-auto p-2 bd-highlight">
              <h3
                className="text-dark fw-bolder lh-lg mb-0"
                style={{ fontSize: "1.5rem" }}
              >
                {successFlag
                  ? "Sales Contacted Successfully"
                  : "Autopilot your bank's growth"}
              </h3>
              <div className="text-muted fs-5 fs-3x-6 mt-4">
                {successFlag ? (
                  <>
                    <p>
                      Your message has been successfully sent to our Sales team.
                      They will be in touch with you shortly.
                    </p>
                    <p className="mt-4">Thank you for reaching out!</p>
                  </>
                ) : (
                  <>
                    <p>
                      We can’t wait to see your institution grow with Autopilot
                      from BOND.AI. Our team will be in touch with you very
                      soon.
                    </p>

                    <p
                      style={{
                        display:
                          userRole === "reseller" || userRole === "bond-admin"
                            ? "none"
                            : "block",
                      }}
                    >
                      {/* They will be in touch shortly to assist you further. */}
                    </p>
                  </>
                )}
              </div>
            </div>
            <div
              className="p-2 bd-highlight"
              style={{
                display:
                  userRole === "reseller" || userRole === "bond-admin"
                    ? "none"
                    : "block",
              }}
            >
              {!successFlag && (
                <button
                  type="button"
                  id="kt_login_password_reset_form_cancel_button "
                  className="btn btn-other btn-bond px-8 py-3"
                  data-toggle="collapse"
                  href="#collapseTransactionBlock"
                  aria-expanded="false"
                  aria-controls="collapseTransactionBlock"
                  style={{ pointerEvents: loading ? "none" : "all" }}
                  onClick={() => {
                    handleClick();
                  }}
                >
                  <span
                    className="me-1 fs-5 fs-xxl-6"
                    style={{ fontWeight: "normal" }}
                  >
                    {successFlag ? "Dashboard" : "Contact Sales"}
                  </span>
                  <output
                    className="spinner-grow spinner-grow-sm ms-3"
                    id="btn_spinner"
                    style={{ display: loading ? "inline-flex" : "none" }}
                  />
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

ContactSalesTeamModal.propTypes = {
  onHide: PropTypes.func,
  cardData: PropTypes.shape({
    name: PropTypes.string,
  }),
};
